/* import __COLOCATED_TEMPLATE__ from './change-conversation-priority.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();